<ng-container *ngIf="!this.isPrimeNg; else PrimeNg">
  <div class="form-group row">
    <label class="col-sm-12 font-weight-bold" for="user_id">{{
      this.userid_data.getLabel()
      }}</label>
    <div class="col-sm-12">
      <div class="input-group">
        <div class="input-group-prepend width-35p" *ngIf="this.userid_data.isPhoneNumber()">
          <select name="country" style="text-align: left;" [disabled]="this.userid_data.isDisabled"
            class="input-group-text prepend-of-append-prepend patient_reg_input_border box-shadow-none width-100p notranslate"
            [class.isEmail-login-email-number-code]="this.userid_data.isEmail()"
            [class.isPhoneNumber-login-email-number-code]="
              this.userid_data.isPhoneNumber()
            " [(ngModel)]="this.userid_data.selected_country_data.acronym" #country="ngModel" [class.form-input-error]="
              user_id.invalid &&
              (user_id.dirty || user_id.touched) &&
              (user_id.errors?.required || user_id.errors?.FieldValidator)
            " [class.form-input-success]="
              !user_id.invalid &&
              (user_id.dirty || user_id.touched) &&
              !(user_id.errors?.required && user_id.errors?.FieldValidator)
            " required (ngModelChange)="setCountry()">
            <option value="" class="font-weight-bolder" disabled selected>
              Country Code*
            </option>
            <option *ngFor="let country of this.userid_data.country_codes" value="{{ country.value }}">
              {{ country.label }}
            </option>
          </select>
        </div>
        <input name="user_id" type="text" class="form-control box-shadow-none" [disabled]="this.userid_data.isDisabled"
          [class.isEmail-login-email-number-text]="this.userid_data.isEmail()"
          [class.isPhoneNumber-login-email-number-text]="
            this.userid_data.isPhoneNumber()
          " id="user_id" (keypress)="
            this.userid_data.isPhoneNumber() ? only_number($event) : true
          " aria-describedby="user_id" placeholder="{{ this.userid_data.getLabel() }}"
          [(ngModel)]="this.userid_data.userid_value" #user_id="ngModel" [class.form-input-error]="
            user_id.invalid &&
            (user_id.dirty || user_id.touched) &&
            (user_id.errors?.required || user_id.errors?.FieldValidator)
          " [class.form-input-success]="
            !user_id.invalid &&
            (user_id.dirty || user_id.touched) &&
            !(user_id.errors?.required && user_id.errors?.FieldValidator)
          " required />
      </div>
      <div *ngIf="user_id?.invalid && (user_id?.dirty || user_id?.touched)" class="col-sm-12 pl-0 pr-0">
        <div *ngIf="user_id.errors?.required" class="col-sm-12 alert alert-danger m-2" role="alert">
          Required Field.
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #PrimeNg>
  <div class="ui-g mt-2">
    <label class="ui-g-12" for="user_id">
      {{ this.userid_data.getLabel() }}
    </label>
    <div class="ui-g-12">
      <div class="input-group">
        <p-dropdown
          class="notranslate input-group-text changedropdown edit-mobile-dropdown patient_reg_input_border box-shadow-none width-35p"
          [class.isEmail-primeng-userid-phone-number-code]="
            this.userid_data.isEmail()
          " [disabled]="this.userid_data.isDisabled" [class.isPhoneNumber-primeng-userid-phone-number-code]="
            this.userid_data.isPhoneNumber()
          " (keypress)="
            this.userid_data.isPhoneNumber() ? only_number($event) : true
          " [options]="this.userid_data.country_codes" [(ngModel)]="this.userid_data.selected_country_data.acronym"
          placeholder="Country*" name="unique_id_name" #unique_id_name="ngModel" [showClear]="false"
          [style]="{ border: '2px solid #858585;' }" [class.form-input-error]="
            user_id.invalid &&
            (user_id.dirty || user_id.touched) &&
            (user_id.errors?.required || user_id.errors?.FieldValidator)
          " [class.form-input-success]="
            !user_id.invalid &&
            (user_id.dirty || user_id.touched) &&
            !(user_id.errors?.required && user_id.errors?.FieldValidator)
          ">
        </p-dropdown>
        <input pInputText name="user_id" type="text" [disabled]="this.userid_data.isDisabled"
          [class.isEmail-primeng-userid-email]="this.userid_data.isEmail()"
          [class.isPhoneNumber-primeng-userid-phone-number]="
            this.userid_data.isPhoneNumber()
          " id="user_id" aria-describedby="user_id" placeholder="{{ this.userid_data.getLabel() }}"
          [(ngModel)]="this.userid_data.userid_value" #user_id="ngModel" [class.form-input-error]="
            user_id.invalid &&
            (user_id.dirty || user_id.touched) &&
            (user_id.errors?.required || user_id.errors?.FieldValidator)
          " [class.form-input-success]="
            !user_id.invalid &&
            (user_id.dirty || user_id.touched) &&
            !(user_id.errors?.required && user_id.errors?.FieldValidator)
          " required style="padding-left: 33px !important" />
      </div>
    </div>
    <div *ngIf="user_id?.invalid && (user_id?.dirty || user_id?.touched)" class="ui-g-12 pl-2">
      <div *ngIf="user_id.errors?.required" class="ui-g-12 alert alert-danger m-2" role="alert">
        Required Field.
      </div>
    </div>
  </div>
</ng-template>